import { combineReducers } from "redux";

import network from "./network.reducer";
import ui from "./ui.reducer";
import smart from "./smart.reducer";
import jobs from "./jobs.reducer";
import applications from "./applications.reducer";
import users from "./users.reducer";
import advertising from "./advertising.reducer";
import linktree from "./linktree.reducer";
import locations from "./location.reducer";

export default combineReducers({
  network,
  ui,
  smart,
  jobs,
  applications,
  users,
  advertising,
  linktree,
  locations,
});
